import dynamic from 'next/dynamic'

export const EmbeddedTypeform = dynamic(() => import('./embedded-typeform'), {
    ssr: false,
})
